(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});


parcelRegister("iEAYo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d948a48149b4e09f$export$2e2bcd8739ae039; });

var $2Xzd1 = parcelRequire("2Xzd1");

var $1Pbk2 = parcelRequire("1Pbk2");
var $d948a48149b4e09f$var$handleAddToBox = {
    init: function(section) {
        var _this = this;
        if (!section) return;
        var addToBox = section.querySelectorAll('.document_row__icons__single--box');
        addToBox.forEach(function(button) {
            button.addEventListener('click', function(event) {
                event.preventDefault();
                if (button.classList.contains('external-disabled')) return;
                var parent = button.closest('.document_row');
                var attachments = [
                    parent.getAttribute('data-id')
                ];
                _this.addToBox(attachments, 'boxed_documents');
            });
        });
        this.updateBadgeCount();
        setInterval(function() {
            _this.updateBadgeCount();
        }, 500);
    },
    updateBadgeCount: function() {
        var cookieDocuments = (0, $1Pbk2.default).getCookie('boxed_documents');
        var cookieVariants = (0, $1Pbk2.default).getCookie('product_variants');
        var itemsCookieDocuments = cookieDocuments ? cookieDocuments.split(',') : [];
        var itemsCookieVariants = cookieVariants ? JSON.parse(cookieVariants) : [];
        length = itemsCookieDocuments.length + itemsCookieVariants.length;
        this.updateHeaderBoxQuantity(length);
    },
    addToBox: function(newValues, cookieName) {
        var COOKIE_PRODUCT_VARIANTS = 'product_variants';
        var COOKIE_BOXES_DOCUMENTS = 'boxed_documents';
        var cookieDocuments = (0, $1Pbk2.default).getCookie(COOKIE_BOXES_DOCUMENTS);
        var cookieVariants = (0, $1Pbk2.default).getCookie(COOKIE_PRODUCT_VARIANTS);
        var itemsCookieDocuments = cookieDocuments ? cookieDocuments.split(',') : [];
        var itemsCookieVariants = cookieVariants ? JSON.parse(cookieVariants) : [];
        var length1 = 0;
        if (cookieName === COOKIE_BOXES_DOCUMENTS) {
            var postsWithLanguages = [];
            newValues.forEach(function(post_id) {
                var checked_languages = document.querySelectorAll('[id^="document-language-'.concat(post_id, '"]:checked'));
                if (checked_languages.length) checked_languages.forEach(function(ch) {
                    postsWithLanguages.push(ch.value);
                });
                else postsWithLanguages.push(post_id);
            });
            var uniqCookieDocuments = (0, $2Xzd1._)(new Set((0, $2Xzd1._)(itemsCookieDocuments).concat((0, $2Xzd1._)(postsWithLanguages))));
            var documentPosts = [];
            uniqCookieDocuments.forEach(function(row) {
                var columns = row.split('-');
                documentPosts.push(columns[0]);
            });
            var documentPostsUnique = (0, $2Xzd1._)(new Set(documentPosts));
            length1 = documentPostsUnique.length + cookieVariants.size;
            (0, $1Pbk2.default).setCookie(COOKIE_BOXES_DOCUMENTS, uniqCookieDocuments.join(','), 1);
        } else if (cookieName === COOKIE_PRODUCT_VARIANTS) {
            var updatedVariantsMap = new Map();
            if (itemsCookieVariants) itemsCookieVariants.forEach(function(param) {
                var id = param.id, quantity = param.quantity;
                updatedVariantsMap.set(id, {
                    id: id,
                    quantity: quantity
                });
            });
            newValues.forEach(function(param) {
                var id = param.id, quantity = param.quantity;
                if (updatedVariantsMap.has(id)) {
                    var existing = updatedVariantsMap.get(id);
                    updatedVariantsMap.set(id, {
                        id: id,
                        quantity: existing.quantity + quantity
                    });
                } else updatedVariantsMap.set(id, {
                    id: id,
                    quantity: quantity
                });
            });
            length1 = itemsCookieDocuments.length + updatedVariantsMap.size;
            (0, $1Pbk2.default).setCookie(COOKIE_PRODUCT_VARIANTS, JSON.stringify((0, $2Xzd1._)(updatedVariantsMap.values())), 1);
        }
        this.updateHeaderBoxQuantity(length1);
    },
    updateHeaderBoxQuantity: function(length1) {
        document.querySelectorAll('.download-button__quantity').forEach(function(count) {
            if (length1 > 0) {
                count.innerHTML = length1;
                count.classList.remove('hidden');
            } else count.classList.add('hidden');
        });
    },
    removeFromBox: function(removeValues, cookieName) {
        var cookieDocuments = (0, $1Pbk2.default).getCookie('boxed_documents');
        var cookieVariants = (0, $1Pbk2.default).getCookie('product_variants');
        var itemsCookieDocuments = cookieDocuments ? cookieDocuments.split(',') : [];
        var itemsCookieVariants = cookieVariants ? JSON.parse(cookieVariants) : [];
        var length1 = 0;
        if (cookieName === 'boxed_documents') {
            var cookieDocumentsLeft = itemsCookieDocuments.filter(function(itemCookieDocument) {
                var found = removeValues.some(function(removeValue) {
                    return itemCookieDocument.indexOf(removeValue) !== -1;
                });
                return !found;
            });
            length1 = cookieDocumentsLeft.length + itemsCookieVariants.length;
            (0, $1Pbk2.default).setCookie('boxed_documents', cookieDocumentsLeft.join(','), 1);
        } else if (cookieName === 'product_variants') {
            var cookieVariantsLeft = itemsCookieVariants.filter(function(itemCookieVariant) {
                return !removeValues.includes(itemCookieVariant.id);
            });
            length1 = cookieVariantsLeft.length + itemsCookieDocuments.length;
            (0, $1Pbk2.default).setCookie('product_variants', JSON.stringify((0, $2Xzd1._)(cookieVariantsLeft.values())), 1);
        }
        this.updateHeaderBoxQuantity(length1);
    }
};
var $d948a48149b4e09f$export$2e2bcd8739ae039 = $d948a48149b4e09f$var$handleAddToBox;

});
parcelRegister("1Pbk2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1543563250552b44$export$2e2bcd8739ae039; });

var $2Xzd1 = parcelRequire("2Xzd1");
var $1543563250552b44$var$_instance;
var $1543563250552b44$var$utils = {
    throttle: function(func, limit) {
        var inThrottle;
        return function() {
            var args = arguments;
            var context = this;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(function() {
                    return inThrottle = false;
                }, limit);
            }
        };
    },
    debounce: function(func, delay) {
        var inDebounce;
        return function() {
            var context = this;
            var args = arguments;
            clearTimeout(inDebounce);
            inDebounce = setTimeout(function() {
                return func.apply(context, args);
            }, delay);
        };
    },
    /**
	 * scale initial values between range
	 * @param {Number} num num
	 * @param {Number} in_min in_min
	 * @param {Number} in_max in_max
	 * @param {Number} out_min out_min
	 * @param {Number} out_max out_max
	 */ scale: function(num, in_min, in_max) {
        var out_min = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, out_max = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 100;
        return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
    },
    /**
	 * return random int
	 * @param {Number} min min
	 * @param {Number} max max
	 */ random: function() {
        var min = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 9999;
        return Math.floor(Math.random() * (max - min + 1) + min);
    },
    /**
	 * Return a shuffled copy of an Array
	 * @param {Array} array array
	 */ shuffle: function(array) {
        return array.slice().sort(function() {
            return Math.random() - 0.5;
        });
    },
    /**
	 * Flatterns multidimensional Array
	 * @param {Array} array array
	 */ flatten: function(array) {
        return ($1543563250552b44$var$_instance = []).concat.apply($1543563250552b44$var$_instance, (0, $2Xzd1._)(array));
    },
    removeDupliates: function(array) {
        return (0, $2Xzd1._)(new Set(array));
    },
    getHex: function() {
        return "#".concat(Math.floor(Math.random() * 0xffffff).toString(16).padEnd(6, '0'));
    },
    getQuery: function() {
        return document.location.search.replace(/(^\?)/, '').split('&').reduce(function(o, n) {
            n = n.split('=');
            o[n[0]] = n[1];
            return o;
        }, {});
    },
    setCookie: function(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 86400000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie: function(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == ' ')c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    },
    /**
	 * Detect phone/tablet
	 */ isMobile: function() {
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) return true;
        return false;
    },
    /**
	 * Go to srollpos
	 * @param {Int} y Offset Y
	 */ goTo: function(selector, callback) {
        document.body.scrollTop = document.documentElement.scrollTop = y;
    },
    getElem: function(selector, callback) {
        var selectors = document.querySelectorAll(selector);
        [].forEach.call(selectors, callback);
    },
    clone: function(el) {
        this.getElem(el, function(element) {
            var count = element.getAttribute('data-clone');
            for(var i = 0; i < +count - 1; i++){
                var node = element.cloneNode(true);
                node.setAttribute('data-clone', 'clone');
                element.parentElement.appendChild(node);
            }
        });
    }
};
var $1543563250552b44$export$2e2bcd8739ae039 = $1543563250552b44$var$utils;

});



var $2Xzd1 = parcelRequire("2Xzd1");

var $iEAYo = parcelRequire("iEAYo");
var $16869b531c656c32$var$download = {
    init: function() {
        var _this = this;
        document.querySelectorAll('.download').forEach(function(section) {
            _this.handleSelectedRows(section);
            (0, $iEAYo.default).init(section);
            section.querySelectorAll('.download__header__filters__single').forEach(function(filter) {
                _this.handleSelect(filter, section);
            });
            section.querySelector('#download-selected-files').addEventListener('click', function() {
                var documentRows = section.querySelectorAll('input[name="selected_documents"]:checked');
                var attachments = [];
                documentRows.forEach(function(documentRow) {
                    var all_languages = section.querySelectorAll('[name^="document-language-'.concat(documentRow.value, '"]'));
                    all_languages.forEach(function(attachment) {
                        attachments.push(attachment.value);
                    });
                });
                window.open("".concat(download_php.documents_endpoint, "?selected_documents=").concat(attachments.join(',')));
            });
            section.querySelector('#add-to-download-box').addEventListener('click', function() {
                var productLines = section.querySelectorAll('input[name="selected_documents"]:checked');
                var documents = (0, $2Xzd1._)(productLines).map(function(productLine) {
                    return productLine.value;
                });
                (0, $iEAYo.default).addToBox(documents, 'boxed_documents');
            });
        });
    },
    handleSelectedRows: function(section) {
        section.querySelectorAll('.document_row__name').forEach(function(row) {
            row.addEventListener('click', function() {
                var checkboxes = section.querySelectorAll('.document_row__name--document input:checked');
                var download_section = section.querySelector('.download__download');
                section.querySelectorAll('.download__download__button .count').forEach(function(count) {
                    count.innerHTML = '(' + checkboxes.length + ')';
                });
                if (checkboxes.length > 0) download_section.classList.add('active');
                else download_section.classList.remove('active');
            });
        });
    },
    handleSelect: function(element, section) {
        if (!element) return;
        element.addEventListener('click', function(e) {
            e.stopImmediatePropagation();
            if (element.classList.contains('active')) {
                element.classList.remove('active');
                return;
            }
            section.querySelectorAll('.download__header__filters__single').forEach(function(filter) {
                filter.classList.remove('active');
            });
            section.querySelectorAll('.document_row__language').forEach(function(language_select) {
                language_select.classList.remove('active');
            });
            element.classList.toggle('active');
        });
        document.addEventListener('click', function(event) {
            if (!element.contains(event.target)) element.classList.remove('active');
        });
    }
};
document.addEventListener('DOMContentLoaded', function() {
    $16869b531c656c32$var$download.init();
});

})();
//# sourceMappingURL=script.js.map
